export function formatBillingPeriod(startDate?: string, endDate?: string): string {
  if (!startDate || !endDate) return 'Missing Data';
  const start = new Date(startDate).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
  const end = new Date(endDate).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
  return `${start} - ${end}`;
}
